var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEdit = function SvgEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34_11137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 17.3547H4.16667C3.94566 17.3547 3.73369 17.4425 3.57741 17.5988C3.42113 17.7551 3.33334 17.967 3.33334 18.188C3.33334 18.409 3.42113 18.621 3.57741 18.7773C3.73369 18.9336 3.94566 19.0214 4.16667 19.0214H15.8333C16.0544 19.0214 16.2663 18.9336 16.4226 18.7773C16.5789 18.621 16.6667 18.409 16.6667 18.188C16.6667 17.967 16.5789 17.7551 16.4226 17.5988C16.2663 17.4425 16.0544 17.3547 15.8333 17.3547ZM4.16667 15.688H4.24167L7.71667 15.3714C8.09733 15.3334 8.45337 15.1657 8.725 14.8964L16.225 7.39637C16.5161 7.08884 16.6734 6.67846 16.6625 6.25515C16.6516 5.83184 16.4733 5.43012 16.1667 5.13803L13.8833 2.8547C13.5853 2.57478 13.1948 2.41416 12.7861 2.40341C12.3774 2.39265 11.979 2.53251 11.6667 2.79637L4.16667 10.2964C3.89731 10.568 3.72959 10.924 3.69167 11.3047L3.33334 14.7797C3.32211 14.9018 3.33795 15.0248 3.37972 15.14C3.42149 15.2553 3.48817 15.3599 3.575 15.4464C3.65287 15.5236 3.74522 15.5847 3.84675 15.6262C3.94828 15.6676 4.057 15.6887 4.16667 15.688ZM12.725 4.02137L15 6.29637L13.3333 7.92137L11.1 5.68803L12.725 4.02137Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34_11137"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.687988)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit.70d46d0b.svg";
export { ForwardRef as ReactComponent };